var map = {
	"./de/50dragonLP.json": [
		49065,
		49065
	],
	"./de/50zillaOctober2025LP.json": [
		79219,
		79219
	],
	"./de/CardsBenefitsJune2025LP.json": [
		53846,
		53846
	],
	"./de/QuizBonusJune2025LP.json": [
		55214,
		55214
	],
	"./de/StValentine2026.json": [
		82187,
		82187
	],
	"./de/aviatorup.json": [
		60011,
		60011
	],
	"./de/banksBenefitsMay2025.json": [
		77207,
		77207
	],
	"./de/banksBenefitsOctober2025LP.json": [
		45284,
		45284
	],
	"./de/banksBenefitsSpooky2025LP.json": [
		49557,
		49557
	],
	"./de/becomeVip.json": [
		44979,
		44979
	],
	"./de/bigBass.json": [
		84369,
		84369
	],
	"./de/blackWheelLP.json": [
		30241,
		30241
	],
	"./de/bonanzaPromo.json": [
		94504,
		94504
	],
	"./de/bonusClaimLP.json": [
		46295,
		46295
	],
	"./de/bonusShop.json": [
		51947,
		51947
	],
	"./de/bonuses.json": [
		99915,
		99915
	],
	"./de/buffaloWheel.json": [
		90322,
		90322
	],
	"./de/cardsBenefitsAugust2025LP.json": [
		67426,
		67426
	],
	"./de/cardsBenefitsNovember2025LP.json": [
		69456,
		69456
	],
	"./de/carways2025LP.json": [
		43148,
		43148
	],
	"./de/cashbox.json": [
		78200,
		78200
	],
	"./de/cashupBonanza.json": [
		15087,
		15087
	],
	"./de/centredRegFormLP.json": [
		38325,
		38325
	],
	"./de/chickenupLP.json": [
		17740,
		17740
	],
	"./de/circleLP.json": [
		81184,
		81184
	],
	"./de/circusNovember.json": [
		57637,
		57637
	],
	"./de/coinupLP.json": [
		3889,
		3889
	],
	"./de/common.json": [
		2938,
		2938
	],
	"./de/crownApril25.json": [
		68710,
		68710
	],
	"./de/crownBanner.json": [
		96026,
		96026
	],
	"./de/crownMarch25.json": [
		83105,
		83105
	],
	"./de/crownWheelBlack.json": [
		92486,
		92486
	],
	"./de/crownWheelBlackLP.json": [
		35124,
		35124
	],
	"./de/cryptoExclusiveMay25LP.json": [
		14387,
		14387
	],
	"./de/cryptoOfferMay25LP.json": [
		95007,
		95007
	],
	"./de/deposits.json": [
		51972,
		51972
	],
	"./de/dialogs.json": [
		46428,
		46428
	],
	"./de/diceRoll.json": [
		16226,
		16226
	],
	"./de/dogTreasure.json": [
		73247,
		73247
	],
	"./de/dogTreasureTerms.json": [
		80886,
		80886
	],
	"./de/dragonLP.json": [
		81425,
		81425
	],
	"./de/dragonPearlsCoverflowLPTemplate.json": [
		26627,
		26627
	],
	"./de/dragonPearlsFebruary2026.json": [
		2089,
		2089
	],
	"./de/dragonPearlsMarch2026.json": [
		53264,
		53264
	],
	"./de/dragonPearlsNovember25LP.json": [
		76718,
		76718
	],
	"./de/easterApril2025.json": [
		26994,
		26994
	],
	"./de/easterApril2026.json": [
		55663,
		55663
	],
	"./de/easterMissions.json": [
		3546,
		3546
	],
	"./de/fiestaJune25LP.json": [
		96261,
		96261
	],
	"./de/fifa2026LP.json": [
		28541,
		28541
	],
	"./de/fruitCircusParty.json": [
		81725,
		81725
	],
	"./de/fruitsupMarch25.json": [
		73471,
		73471
	],
	"./de/gatesOfOlympusLP.json": [
		72264,
		72264
	],
	"./de/glossary.json": [
		69115,
		69115
	],
	"./de/halloween2026LP.json": [
		15736,
		15736
	],
	"./de/halloweenPromo26.json": [
		72228,
		72228
	],
	"./de/headlinePromo.json": [
		67515,
		67515
	],
	"./de/history.json": [
		88559,
		88559
	],
	"./de/jackpot.json": [
		77783,
		77783
	],
	"./de/juicyCarMay2025.json": [
		83214,
		83214
	],
	"./de/juicyMay.json": [
		35851,
		35851
	],
	"./de/kickupLP.json": [
		53347,
		53347
	],
	"./de/leaveDeposit.json": [
		23251,
		23251
	],
	"./de/leaveRegistration.json": [
		30979,
		30979
	],
	"./de/limits.json": [
		57546,
		57546
	],
	"./de/lobby.json": [
		88804,
		88804
	],
	"./de/lootboxes.json": [
		90603,
		90603
	],
	"./de/loyalty.json": [
		81133,
		81133
	],
	"./de/lpAssets.json": [
		99434,
		99434
	],
	"./de/lyzer40BanksBenefitsJune2025LP.json": [
		86692,
		86692
	],
	"./de/march2025.json": [
		25915,
		25915
	],
	"./de/matchlvlLP.json": [
		95063,
		95063
	],
	"./de/mission.json": [
		1953,
		1953
	],
	"./de/mobileApp.json": [
		33409,
		33409
	],
	"./de/mybeerLP.json": [
		26650,
		26650
	],
	"./de/odyssey-promo.json": [
		99353,
		99353
	],
	"./de/offerCardNovember2025LP.json": [
		20734,
		20734
	],
	"./de/oktoberfest.json": [
		23295,
		23295
	],
	"./de/personal.json": [
		21518,
		21518
	],
	"./de/profile.json": [
		35158,
		35158
	],
	"./de/promotions.json": [
		31464,
		31464
	],
	"./de/pumpkinKingdom.json": [
		77513,
		77513
	],
	"./de/quest.json": [
		9348,
		9348
	],
	"./de/redDragon3.json": [
		86787,
		86787
	],
	"./de/referralSystem.json": [
		370,
		370
	],
	"./de/regDragonRewards.json": [
		51316,
		51316
	],
	"./de/regDragonRewardsAugust25LP.json": [
		37126,
		64421
	],
	"./de/regDragonRewardsOctober25LP.json": [
		65933,
		65933
	],
	"./de/regDragonRewardsSports.json": [
		75520,
		75520
	],
	"./de/regRewards.json": [
		49635,
		49635
	],
	"./de/rewards.json": [
		58016,
		58016
	],
	"./de/royalupLP.json": [
		24949,
		24949
	],
	"./de/scoreupLP.json": [
		33491,
		33491
	],
	"./de/scratchGame.json": [
		70914,
		70914
	],
	"./de/security.json": [
		36798,
		36798
	],
	"./de/sharkJuly25LP.json": [
		34768,
		34768
	],
	"./de/slotsCircle.json": [
		96047,
		96047
	],
	"./de/slotsStepsAugust2025LP.json": [
		6816,
		6816
	],
	"./de/slotwinLP.json": [
		64608,
		64608
	],
	"./de/sportsDeposit.json": [
		64412,
		64412
	],
	"./de/sportslvlLP.json": [
		77242,
		77242
	],
	"./de/stPatrick2026.json": [
		92964,
		92964
	],
	"./de/sunOfEgypt.json": [
		87116,
		87116
	],
	"./de/support.json": [
		53227,
		53227
	],
	"./de/tournaments.json": [
		77506,
		77506
	],
	"./de/turbolvlJuly25LP.json": [
		23779,
		23779
	],
	"./de/validation.json": [
		21621,
		21621
	],
	"./de/verification.json": [
		6114,
		6114
	],
	"./de/vip.json": [
		78534,
		78534
	],
	"./de/vipGemCards.json": [
		13554,
		13554
	],
	"./de/welcomeApril2025.json": [
		47414,
		47414
	],
	"./de/welcomeSeptemberLP.json": [
		28024,
		28342
	],
	"./de/wheel.json": [
		36793,
		36793
	],
	"./de/wheelFortuneLP.json": [
		42123,
		42123
	],
	"./de/winterJanuary.json": [
		35168,
		35168
	],
	"./de/withdraw.json": [
		15401,
		15401
	],
	"./de/wolfElvisSunBuffalo.json": [
		33865,
		33865
	],
	"./de/wolfWheelLP.json": [
		84879,
		84879
	],
	"./de/worldcup2026LP.json": [
		27600,
		27600
	],
	"./de/xmasJanuary2026.json": [
		9516,
		9516
	],
	"./de/xmasbonusNovember2025LP.json": [
		76670,
		76670
	],
	"./en-AU/50dragonLP.json": [
		35210,
		35210
	],
	"./en-AU/50zillaOctober2025LP.json": [
		95640,
		33339
	],
	"./en-AU/CardsBenefitsJune2025LP.json": [
		37651,
		33183
	],
	"./en-AU/QuizBonusJune2025LP.json": [
		48023,
		48023
	],
	"./en-AU/StValentine2026.json": [
		85287,
		85287
	],
	"./en-AU/aviatorup.json": [
		24052,
		24052
	],
	"./en-AU/banksBenefitsMay2025.json": [
		49390,
		49390
	],
	"./en-AU/banksBenefitsOctober2025LP.json": [
		10682,
		10682
	],
	"./en-AU/banksBenefitsSpooky2025LP.json": [
		19821,
		19821
	],
	"./en-AU/becomeVip.json": [
		39083,
		39083
	],
	"./en-AU/bigBass.json": [
		50581,
		50581
	],
	"./en-AU/blackWheelLP.json": [
		2580,
		2580
	],
	"./en-AU/bonanzaPromo.json": [
		6838,
		6838
	],
	"./en-AU/bonusClaimLP.json": [
		15618,
		15618
	],
	"./en-AU/bonusShop.json": [
		91465,
		91465
	],
	"./en-AU/bonuses.json": [
		66240,
		66240
	],
	"./en-AU/buffaloWheel.json": [
		44909,
		44909
	],
	"./en-AU/cardsBenefitsAugust2025LP.json": [
		57549,
		57549
	],
	"./en-AU/cardsBenefitsNovember2025LP.json": [
		20154,
		20154
	],
	"./en-AU/carways2025LP.json": [
		81973,
		81973
	],
	"./en-AU/cashbox.json": [
		29007,
		29007
	],
	"./en-AU/cashupBonanza.json": [
		26447,
		26447
	],
	"./en-AU/centredRegFormLP.json": [
		11268,
		11268
	],
	"./en-AU/chickenupLP.json": [
		35402,
		35402
	],
	"./en-AU/circleLP.json": [
		8960,
		8960
	],
	"./en-AU/circusNovember.json": [
		76279,
		76279
	],
	"./en-AU/coinupLP.json": [
		99597,
		99597
	],
	"./en-AU/common.json": [
		95556,
		29774
	],
	"./en-AU/crownApril25.json": [
		7306,
		7306
	],
	"./en-AU/crownBanner.json": [
		92357,
		92357
	],
	"./en-AU/crownMarch25.json": [
		36417,
		36417
	],
	"./en-AU/crownWheelBlack.json": [
		62092,
		62092
	],
	"./en-AU/crownWheelBlackLP.json": [
		40494,
		40494
	],
	"./en-AU/cryptoExclusiveMay25LP.json": [
		15974,
		15974
	],
	"./en-AU/cryptoOfferMay25LP.json": [
		95682,
		95682
	],
	"./en-AU/deposits.json": [
		5773,
		5773
	],
	"./en-AU/dialogs.json": [
		72012,
		72012
	],
	"./en-AU/diceRoll.json": [
		9941,
		9941
	],
	"./en-AU/dogTreasure.json": [
		96292,
		96292
	],
	"./en-AU/dogTreasureTerms.json": [
		57813,
		57813
	],
	"./en-AU/dragonLP.json": [
		98535,
		98535
	],
	"./en-AU/dragonPearlsCoverflowLPTemplate.json": [
		43351,
		43351
	],
	"./en-AU/dragonPearlsFebruary2026.json": [
		57877,
		57877
	],
	"./en-AU/dragonPearlsMarch2026.json": [
		32383,
		32383
	],
	"./en-AU/dragonPearlsNovember25LP.json": [
		26979,
		26979
	],
	"./en-AU/easterApril2025.json": [
		50450,
		50450
	],
	"./en-AU/easterApril2026.json": [
		90366,
		90366
	],
	"./en-AU/easterMissions.json": [
		41412,
		41412
	],
	"./en-AU/fiestaJune25LP.json": [
		92799,
		92799
	],
	"./en-AU/fifa2026LP.json": [
		63023,
		63023
	],
	"./en-AU/fruitCircusParty.json": [
		14521,
		14521
	],
	"./en-AU/fruitsupMarch25.json": [
		53942,
		53942
	],
	"./en-AU/gatesOfOlympusLP.json": [
		90797,
		90797
	],
	"./en-AU/glossary.json": [
		42609,
		42609
	],
	"./en-AU/halloween2026LP.json": [
		65359,
		57959
	],
	"./en-AU/halloweenPromo26.json": [
		46048,
		97504
	],
	"./en-AU/headlinePromo.json": [
		88041,
		88041
	],
	"./en-AU/history.json": [
		73859,
		73859
	],
	"./en-AU/jackpot.json": [
		33364,
		33364
	],
	"./en-AU/juicyCarMay2025.json": [
		82399,
		82399
	],
	"./en-AU/juicyMay.json": [
		458,
		458
	],
	"./en-AU/kickupLP.json": [
		71267,
		71267
	],
	"./en-AU/leaveDeposit.json": [
		27057,
		27057
	],
	"./en-AU/leaveRegistration.json": [
		31167,
		31167
	],
	"./en-AU/limits.json": [
		69107,
		69107
	],
	"./en-AU/lobby.json": [
		65158,
		65158
	],
	"./en-AU/lootboxes.json": [
		25889,
		25889
	],
	"./en-AU/loyalty.json": [
		98524,
		98524
	],
	"./en-AU/lpAssets.json": [
		81854,
		81854
	],
	"./en-AU/lyzer40BanksBenefitsJune2025LP.json": [
		51977,
		51977
	],
	"./en-AU/march2025.json": [
		26776,
		26776
	],
	"./en-AU/matchlvlLP.json": [
		70759,
		70759
	],
	"./en-AU/mission.json": [
		21478,
		21478
	],
	"./en-AU/mobileApp.json": [
		82649,
		82649
	],
	"./en-AU/mybeerLP.json": [
		24803,
		24803
	],
	"./en-AU/odyssey-promo.json": [
		19241,
		19241
	],
	"./en-AU/offerCardNovember2025LP.json": [
		6199,
		6199
	],
	"./en-AU/oktoberfest.json": [
		76700,
		76700
	],
	"./en-AU/personal.json": [
		32042,
		32042
	],
	"./en-AU/profile.json": [
		82082,
		82082
	],
	"./en-AU/promotions.json": [
		30196,
		30196
	],
	"./en-AU/pumpkinKingdom.json": [
		13259,
		13259
	],
	"./en-AU/quest.json": [
		42513,
		42513
	],
	"./en-AU/redDragon3.json": [
		19875,
		19875
	],
	"./en-AU/referralSystem.json": [
		11804,
		11804
	],
	"./en-AU/regDragonRewards.json": [
		34217,
		34217
	],
	"./en-AU/regDragonRewardsAugust25LP.json": [
		64336,
		64336
	],
	"./en-AU/regDragonRewardsOctober25LP.json": [
		39643,
		39643
	],
	"./en-AU/regDragonRewardsSports.json": [
		3860,
		3860
	],
	"./en-AU/regRewards.json": [
		29242,
		29242
	],
	"./en-AU/rewards.json": [
		49881,
		49881
	],
	"./en-AU/royalupLP.json": [
		55683,
		55683
	],
	"./en-AU/scoreupLP.json": [
		58115,
		58115
	],
	"./en-AU/scratchGame.json": [
		5792,
		5792
	],
	"./en-AU/security.json": [
		2716,
		2716
	],
	"./en-AU/sharkJuly25LP.json": [
		76854,
		76854
	],
	"./en-AU/slotsCircle.json": [
		15014,
		15014
	],
	"./en-AU/slotsStepsAugust2025LP.json": [
		93829,
		93829
	],
	"./en-AU/slotwinLP.json": [
		42707,
		42707
	],
	"./en-AU/sportsDeposit.json": [
		4015,
		4015
	],
	"./en-AU/sportslvlLP.json": [
		82113,
		82113
	],
	"./en-AU/stPatrick2026.json": [
		89948,
		89948
	],
	"./en-AU/sunOfEgypt.json": [
		66490,
		66490
	],
	"./en-AU/support.json": [
		36346,
		36346
	],
	"./en-AU/tournaments.json": [
		84900,
		84900
	],
	"./en-AU/turbolvlJuly25LP.json": [
		96312,
		96312
	],
	"./en-AU/validation.json": [
		91447,
		91447
	],
	"./en-AU/verification.json": [
		13823,
		13823
	],
	"./en-AU/vip.json": [
		7218,
		7218
	],
	"./en-AU/vipGemCards.json": [
		65508,
		65508
	],
	"./en-AU/welcomeApril2025.json": [
		15730,
		15730
	],
	"./en-AU/welcomeSeptemberLP.json": [
		62022,
		62022
	],
	"./en-AU/wheel.json": [
		72125,
		72125
	],
	"./en-AU/wheelFortuneLP.json": [
		17103,
		17103
	],
	"./en-AU/winterJanuary.json": [
		35369,
		35369
	],
	"./en-AU/withdraw.json": [
		79511,
		79511
	],
	"./en-AU/wolfElvisSunBuffalo.json": [
		10349,
		10349
	],
	"./en-AU/wolfWheelLP.json": [
		5402,
		5402
	],
	"./en-AU/worldcup2026LP.json": [
		85266,
		85266
	],
	"./en-AU/xmasJanuary2026.json": [
		7575,
		7575
	],
	"./en-AU/xmasbonusNovember2025LP.json": [
		44346,
		44346
	],
	"./en-CA/50dragonLP.json": [
		72663,
		72663
	],
	"./en-CA/50zillaOctober2025LP.json": [
		4233,
		4233
	],
	"./en-CA/CardsBenefitsJune2025LP.json": [
		90930,
		90930
	],
	"./en-CA/QuizBonusJune2025LP.json": [
		85191,
		85191
	],
	"./en-CA/StValentine2026.json": [
		54099,
		54099
	],
	"./en-CA/aviatorup.json": [
		38849,
		38849
	],
	"./en-CA/banksBenefitsMay2025.json": [
		86918,
		86918
	],
	"./en-CA/banksBenefitsOctober2025LP.json": [
		88614,
		88614
	],
	"./en-CA/banksBenefitsSpooky2025LP.json": [
		3000,
		3000
	],
	"./en-CA/becomeVip.json": [
		23904,
		23904
	],
	"./en-CA/bigBass.json": [
		80239,
		80239
	],
	"./en-CA/blackWheelLP.json": [
		20273,
		20273
	],
	"./en-CA/bonanzaPromo.json": [
		62107,
		62107
	],
	"./en-CA/bonusClaimLP.json": [
		46694,
		46694
	],
	"./en-CA/bonusShop.json": [
		63127,
		63127
	],
	"./en-CA/bonuses.json": [
		53950,
		53950
	],
	"./en-CA/buffaloWheel.json": [
		37744,
		37744
	],
	"./en-CA/cardsBenefitsAugust2025LP.json": [
		37164,
		37164
	],
	"./en-CA/cardsBenefitsNovember2025LP.json": [
		1257,
		1257
	],
	"./en-CA/carways2025LP.json": [
		20800,
		20800
	],
	"./en-CA/cashbox.json": [
		80949,
		80949
	],
	"./en-CA/cashupBonanza.json": [
		82605,
		82605
	],
	"./en-CA/centredRegFormLP.json": [
		94082,
		94082
	],
	"./en-CA/chickenupLP.json": [
		7868,
		7868
	],
	"./en-CA/circleLP.json": [
		85570,
		85570
	],
	"./en-CA/circusNovember.json": [
		30406,
		30406
	],
	"./en-CA/coinupLP.json": [
		58957,
		44467
	],
	"./en-CA/common.json": [
		81242,
		81242
	],
	"./en-CA/crownApril25.json": [
		59686,
		59686
	],
	"./en-CA/crownBanner.json": [
		32345,
		32345
	],
	"./en-CA/crownMarch25.json": [
		94959,
		94959
	],
	"./en-CA/crownWheelBlack.json": [
		85016,
		85016
	],
	"./en-CA/crownWheelBlackLP.json": [
		61781,
		61781
	],
	"./en-CA/cryptoExclusiveMay25LP.json": [
		40644,
		40644
	],
	"./en-CA/cryptoOfferMay25LP.json": [
		62749,
		62749
	],
	"./en-CA/deposits.json": [
		20176,
		20176
	],
	"./en-CA/dialogs.json": [
		16793,
		16793
	],
	"./en-CA/diceRoll.json": [
		8406,
		8406
	],
	"./en-CA/dogTreasure.json": [
		4827,
		4827
	],
	"./en-CA/dogTreasureTerms.json": [
		61671,
		61671
	],
	"./en-CA/dragonLP.json": [
		40879,
		40879
	],
	"./en-CA/dragonPearlsCoverflowLPTemplate.json": [
		41075,
		41075
	],
	"./en-CA/dragonPearlsFebruary2026.json": [
		25956,
		25956
	],
	"./en-CA/dragonPearlsMarch2026.json": [
		38215,
		38215
	],
	"./en-CA/dragonPearlsNovember25LP.json": [
		21456,
		21456
	],
	"./en-CA/easterApril2025.json": [
		19858,
		19858
	],
	"./en-CA/easterApril2026.json": [
		73025,
		73025
	],
	"./en-CA/easterMissions.json": [
		90912,
		90912
	],
	"./en-CA/fiestaJune25LP.json": [
		16832,
		16832
	],
	"./en-CA/fifa2026LP.json": [
		94864,
		94864
	],
	"./en-CA/fruitCircusParty.json": [
		8830,
		8830
	],
	"./en-CA/fruitsupMarch25.json": [
		35045,
		35045
	],
	"./en-CA/gatesOfOlympusLP.json": [
		56845,
		56845
	],
	"./en-CA/glossary.json": [
		76053,
		46917
	],
	"./en-CA/halloween2026LP.json": [
		41953,
		41953
	],
	"./en-CA/halloweenPromo26.json": [
		46958,
		46958
	],
	"./en-CA/headlinePromo.json": [
		83212,
		83212
	],
	"./en-CA/history.json": [
		70286,
		70286
	],
	"./en-CA/jackpot.json": [
		67083,
		67083
	],
	"./en-CA/juicyCarMay2025.json": [
		19297,
		19297
	],
	"./en-CA/juicyMay.json": [
		308,
		308
	],
	"./en-CA/kickupLP.json": [
		44586,
		44586
	],
	"./en-CA/leaveDeposit.json": [
		90104,
		90104
	],
	"./en-CA/leaveRegistration.json": [
		39877,
		39877
	],
	"./en-CA/limits.json": [
		89500,
		89500
	],
	"./en-CA/lobby.json": [
		27919,
		27919
	],
	"./en-CA/lootboxes.json": [
		15991,
		15991
	],
	"./en-CA/loyalty.json": [
		66609,
		66609
	],
	"./en-CA/lpAssets.json": [
		28033,
		28033
	],
	"./en-CA/lyzer40BanksBenefitsJune2025LP.json": [
		55702,
		55702
	],
	"./en-CA/march2025.json": [
		21045,
		21045
	],
	"./en-CA/matchlvlLP.json": [
		67969,
		67969
	],
	"./en-CA/mission.json": [
		6976,
		6976
	],
	"./en-CA/mobileApp.json": [
		9116,
		9116
	],
	"./en-CA/mybeerLP.json": [
		24055,
		43699
	],
	"./en-CA/odyssey-promo.json": [
		7094,
		7094
	],
	"./en-CA/offerCardNovember2025LP.json": [
		49327,
		49327
	],
	"./en-CA/oktoberfest.json": [
		77552,
		77552
	],
	"./en-CA/personal.json": [
		6640,
		6640
	],
	"./en-CA/profile.json": [
		50945,
		50945
	],
	"./en-CA/promotions.json": [
		64042,
		64042
	],
	"./en-CA/pumpkinKingdom.json": [
		31101,
		31101
	],
	"./en-CA/quest.json": [
		6379,
		6379
	],
	"./en-CA/redDragon3.json": [
		20094,
		20094
	],
	"./en-CA/referralSystem.json": [
		10284,
		10284
	],
	"./en-CA/regDragonRewards.json": [
		37020,
		37020
	],
	"./en-CA/regDragonRewardsAugust25LP.json": [
		48098,
		48098
	],
	"./en-CA/regDragonRewardsOctober25LP.json": [
		8413,
		8413
	],
	"./en-CA/regDragonRewardsSports.json": [
		32663,
		32663
	],
	"./en-CA/regRewards.json": [
		10586,
		10586
	],
	"./en-CA/rewards.json": [
		76471,
		76471
	],
	"./en-CA/royalupLP.json": [
		22584,
		22584
	],
	"./en-CA/scoreupLP.json": [
		88722,
		88722
	],
	"./en-CA/scratchGame.json": [
		86598,
		86598
	],
	"./en-CA/security.json": [
		51401,
		51401
	],
	"./en-CA/sharkJuly25LP.json": [
		71348,
		71348
	],
	"./en-CA/slotsCircle.json": [
		54810,
		54810
	],
	"./en-CA/slotsStepsAugust2025LP.json": [
		60974,
		60974
	],
	"./en-CA/slotwinLP.json": [
		87832,
		87832
	],
	"./en-CA/sportsDeposit.json": [
		42901,
		42901
	],
	"./en-CA/sportslvlLP.json": [
		85135,
		85135
	],
	"./en-CA/stPatrick2026.json": [
		34316,
		34316
	],
	"./en-CA/sunOfEgypt.json": [
		26748,
		26748
	],
	"./en-CA/support.json": [
		79678,
		79678
	],
	"./en-CA/tournaments.json": [
		55404,
		55404
	],
	"./en-CA/turbolvlJuly25LP.json": [
		93103,
		93103
	],
	"./en-CA/validation.json": [
		66077,
		66077
	],
	"./en-CA/verification.json": [
		70454,
		70454
	],
	"./en-CA/vip.json": [
		38717,
		38717
	],
	"./en-CA/vipGemCards.json": [
		34423,
		34423
	],
	"./en-CA/welcomeApril2025.json": [
		9251,
		9251
	],
	"./en-CA/welcomeSeptemberLP.json": [
		25628,
		25628
	],
	"./en-CA/wheel.json": [
		63956,
		63956
	],
	"./en-CA/wheelFortuneLP.json": [
		42988,
		42988
	],
	"./en-CA/winterJanuary.json": [
		98566,
		98566
	],
	"./en-CA/withdraw.json": [
		6081,
		6081
	],
	"./en-CA/wolfElvisSunBuffalo.json": [
		45293,
		45293
	],
	"./en-CA/wolfWheelLP.json": [
		7527,
		7527
	],
	"./en-CA/worldcup2026LP.json": [
		7095,
		7095
	],
	"./en-CA/xmasJanuary2026.json": [
		75615,
		75615
	],
	"./en-CA/xmasbonusNovember2025LP.json": [
		89397,
		89397
	],
	"./en-IE/50dragonLP.json": [
		16992,
		16992
	],
	"./en-IE/50zillaOctober2025LP.json": [
		24320,
		24320
	],
	"./en-IE/CardsBenefitsJune2025LP.json": [
		79965,
		79965
	],
	"./en-IE/QuizBonusJune2025LP.json": [
		39822,
		39822
	],
	"./en-IE/StValentine2026.json": [
		93278,
		93278
	],
	"./en-IE/aviatorup.json": [
		61932,
		61932
	],
	"./en-IE/banksBenefitsMay2025.json": [
		85982,
		85982
	],
	"./en-IE/banksBenefitsOctober2025LP.json": [
		19381,
		19381
	],
	"./en-IE/banksBenefitsSpooky2025LP.json": [
		27036,
		27036
	],
	"./en-IE/becomeVip.json": [
		83815,
		83815
	],
	"./en-IE/bigBass.json": [
		33412,
		33412
	],
	"./en-IE/blackWheelLP.json": [
		80204,
		80204
	],
	"./en-IE/bonanzaPromo.json": [
		74322,
		74322
	],
	"./en-IE/bonusClaimLP.json": [
		23764,
		23764
	],
	"./en-IE/bonusShop.json": [
		14062,
		14062
	],
	"./en-IE/bonuses.json": [
		41426,
		41426
	],
	"./en-IE/buffaloWheel.json": [
		98358,
		98358
	],
	"./en-IE/cardsBenefitsAugust2025LP.json": [
		42938,
		42938
	],
	"./en-IE/cardsBenefitsNovember2025LP.json": [
		75273,
		75273
	],
	"./en-IE/carways2025LP.json": [
		10248,
		10248
	],
	"./en-IE/cashbox.json": [
		54875,
		54875
	],
	"./en-IE/cashupBonanza.json": [
		85440,
		85440
	],
	"./en-IE/centredRegFormLP.json": [
		67002,
		67002
	],
	"./en-IE/chickenupLP.json": [
		64464,
		64464
	],
	"./en-IE/circleLP.json": [
		51355,
		51355
	],
	"./en-IE/circusNovember.json": [
		48082,
		48082
	],
	"./en-IE/coinupLP.json": [
		57130,
		57130
	],
	"./en-IE/common.json": [
		98403,
		98403
	],
	"./en-IE/crownApril25.json": [
		29827,
		7856
	],
	"./en-IE/crownBanner.json": [
		32181,
		32181
	],
	"./en-IE/crownMarch25.json": [
		65219,
		65219
	],
	"./en-IE/crownWheelBlack.json": [
		54217,
		54217
	],
	"./en-IE/crownWheelBlackLP.json": [
		28485,
		28485
	],
	"./en-IE/cryptoExclusiveMay25LP.json": [
		15142,
		15142
	],
	"./en-IE/cryptoOfferMay25LP.json": [
		27590,
		27590
	],
	"./en-IE/deposits.json": [
		62058,
		62058
	],
	"./en-IE/dialogs.json": [
		58471,
		58471
	],
	"./en-IE/diceRoll.json": [
		94503,
		94503
	],
	"./en-IE/dogTreasure.json": [
		9880,
		9880
	],
	"./en-IE/dogTreasureTerms.json": [
		83268,
		83268
	],
	"./en-IE/dragonLP.json": [
		60789,
		60789
	],
	"./en-IE/dragonPearlsCoverflowLPTemplate.json": [
		44189,
		44189
	],
	"./en-IE/dragonPearlsFebruary2026.json": [
		11145,
		11145
	],
	"./en-IE/dragonPearlsMarch2026.json": [
		47652,
		47652
	],
	"./en-IE/dragonPearlsNovember25LP.json": [
		43767,
		43767
	],
	"./en-IE/easterApril2025.json": [
		15413,
		15413
	],
	"./en-IE/easterApril2026.json": [
		21744,
		75588
	],
	"./en-IE/easterMissions.json": [
		94678,
		94678
	],
	"./en-IE/fiestaJune25LP.json": [
		75457,
		75457
	],
	"./en-IE/fifa2026LP.json": [
		85040,
		85040
	],
	"./en-IE/fruitCircusParty.json": [
		13621,
		13621
	],
	"./en-IE/fruitsupMarch25.json": [
		79130,
		79130
	],
	"./en-IE/gatesOfOlympusLP.json": [
		56250,
		56250
	],
	"./en-IE/glossary.json": [
		46559,
		46559
	],
	"./en-IE/halloween2026LP.json": [
		45461,
		45461
	],
	"./en-IE/halloweenPromo26.json": [
		77259,
		77259
	],
	"./en-IE/headlinePromo.json": [
		20726,
		20726
	],
	"./en-IE/history.json": [
		64998,
		64998
	],
	"./en-IE/jackpot.json": [
		57565,
		57565
	],
	"./en-IE/juicyCarMay2025.json": [
		56378,
		56378
	],
	"./en-IE/juicyMay.json": [
		53421,
		53421
	],
	"./en-IE/kickupLP.json": [
		85320,
		85320
	],
	"./en-IE/leaveDeposit.json": [
		36026,
		36026
	],
	"./en-IE/leaveRegistration.json": [
		62578,
		62578
	],
	"./en-IE/limits.json": [
		14483,
		14483
	],
	"./en-IE/lobby.json": [
		49136,
		49136
	],
	"./en-IE/lootboxes.json": [
		68556,
		68556
	],
	"./en-IE/loyalty.json": [
		8409,
		8409
	],
	"./en-IE/lpAssets.json": [
		55570,
		55570
	],
	"./en-IE/lyzer40BanksBenefitsJune2025LP.json": [
		58254,
		58254
	],
	"./en-IE/march2025.json": [
		49173,
		49173
	],
	"./en-IE/matchlvlLP.json": [
		91962,
		90817
	],
	"./en-IE/mission.json": [
		21125,
		21125
	],
	"./en-IE/mobileApp.json": [
		53075,
		53075
	],
	"./en-IE/mybeerLP.json": [
		21165,
		21165
	],
	"./en-IE/odyssey-promo.json": [
		44895,
		44895
	],
	"./en-IE/offerCardNovember2025LP.json": [
		22265,
		22265
	],
	"./en-IE/oktoberfest.json": [
		5303,
		5303
	],
	"./en-IE/personal.json": [
		74946,
		74946
	],
	"./en-IE/profile.json": [
		92498,
		92498
	],
	"./en-IE/promotions.json": [
		33658,
		33658
	],
	"./en-IE/pumpkinKingdom.json": [
		47915,
		47915
	],
	"./en-IE/quest.json": [
		64012,
		64012
	],
	"./en-IE/redDragon3.json": [
		19087,
		19087
	],
	"./en-IE/referralSystem.json": [
		75378,
		75378
	],
	"./en-IE/regDragonRewards.json": [
		44810,
		44810
	],
	"./en-IE/regDragonRewardsAugust25LP.json": [
		77214,
		24720
	],
	"./en-IE/regDragonRewardsOctober25LP.json": [
		31047,
		31047
	],
	"./en-IE/regDragonRewardsSports.json": [
		72977,
		72977
	],
	"./en-IE/regRewards.json": [
		83797,
		83797
	],
	"./en-IE/rewards.json": [
		72229,
		72229
	],
	"./en-IE/royalupLP.json": [
		66942,
		66942
	],
	"./en-IE/scoreupLP.json": [
		19425,
		16686
	],
	"./en-IE/scratchGame.json": [
		16508,
		16508
	],
	"./en-IE/security.json": [
		68485,
		68485
	],
	"./en-IE/sharkJuly25LP.json": [
		97832,
		97832
	],
	"./en-IE/slotsCircle.json": [
		31283,
		31283
	],
	"./en-IE/slotsStepsAugust2025LP.json": [
		19271,
		19425
	],
	"./en-IE/slotwinLP.json": [
		90101,
		90101
	],
	"./en-IE/sportsDeposit.json": [
		46544,
		46544
	],
	"./en-IE/sportslvlLP.json": [
		98698,
		98698
	],
	"./en-IE/stPatrick2026.json": [
		12717,
		12717
	],
	"./en-IE/sunOfEgypt.json": [
		27162,
		31079
	],
	"./en-IE/support.json": [
		59176,
		59176
	],
	"./en-IE/tournaments.json": [
		93616,
		93616
	],
	"./en-IE/turbolvlJuly25LP.json": [
		24416,
		24416
	],
	"./en-IE/validation.json": [
		96629,
		96629
	],
	"./en-IE/verification.json": [
		74054,
		74054
	],
	"./en-IE/vip.json": [
		44221,
		44221
	],
	"./en-IE/vipGemCards.json": [
		38563,
		38563
	],
	"./en-IE/welcomeApril2025.json": [
		68482,
		68482
	],
	"./en-IE/welcomeSeptemberLP.json": [
		31589,
		31589
	],
	"./en-IE/wheel.json": [
		5879,
		5879
	],
	"./en-IE/wheelFortuneLP.json": [
		17905,
		17905
	],
	"./en-IE/winterJanuary.json": [
		26909,
		26909
	],
	"./en-IE/withdraw.json": [
		79187,
		79187
	],
	"./en-IE/wolfElvisSunBuffalo.json": [
		98560,
		98560
	],
	"./en-IE/wolfWheelLP.json": [
		8518,
		8518
	],
	"./en-IE/worldcup2026LP.json": [
		59584,
		59584
	],
	"./en-IE/xmasJanuary2026.json": [
		2121,
		2121
	],
	"./en-IE/xmasbonusNovember2025LP.json": [
		27203,
		27203
	],
	"./en-NZ/50dragonLP.json": [
		12225,
		12225
	],
	"./en-NZ/50zillaOctober2025LP.json": [
		27564,
		27564
	],
	"./en-NZ/CardsBenefitsJune2025LP.json": [
		76651,
		76651
	],
	"./en-NZ/QuizBonusJune2025LP.json": [
		87945,
		87945
	],
	"./en-NZ/StValentine2026.json": [
		91229,
		91229
	],
	"./en-NZ/aviatorup.json": [
		99322,
		99322
	],
	"./en-NZ/banksBenefitsMay2025.json": [
		80939,
		80939
	],
	"./en-NZ/banksBenefitsOctober2025LP.json": [
		32861,
		32861
	],
	"./en-NZ/banksBenefitsSpooky2025LP.json": [
		516,
		516
	],
	"./en-NZ/becomeVip.json": [
		63801,
		63801
	],
	"./en-NZ/bigBass.json": [
		93534,
		93534
	],
	"./en-NZ/blackWheelLP.json": [
		97606,
		97606
	],
	"./en-NZ/bonanzaPromo.json": [
		15845,
		15845
	],
	"./en-NZ/bonusClaimLP.json": [
		82034,
		82034
	],
	"./en-NZ/bonusShop.json": [
		38271,
		38271
	],
	"./en-NZ/bonuses.json": [
		93208,
		93208
	],
	"./en-NZ/buffaloWheel.json": [
		66860,
		66860
	],
	"./en-NZ/cardsBenefitsAugust2025LP.json": [
		73939,
		73939
	],
	"./en-NZ/cardsBenefitsNovember2025LP.json": [
		684,
		684
	],
	"./en-NZ/carways2025LP.json": [
		66151,
		66151
	],
	"./en-NZ/cashbox.json": [
		24074,
		24074
	],
	"./en-NZ/cashupBonanza.json": [
		10736,
		10736
	],
	"./en-NZ/centredRegFormLP.json": [
		94130,
		94130
	],
	"./en-NZ/chickenupLP.json": [
		90062,
		90062
	],
	"./en-NZ/circleLP.json": [
		63509,
		63509
	],
	"./en-NZ/circusNovember.json": [
		11838,
		11838
	],
	"./en-NZ/coinupLP.json": [
		26117,
		26117
	],
	"./en-NZ/common.json": [
		97853,
		97853
	],
	"./en-NZ/crownApril25.json": [
		51989,
		51989
	],
	"./en-NZ/crownBanner.json": [
		26306,
		26306
	],
	"./en-NZ/crownMarch25.json": [
		55977,
		55977
	],
	"./en-NZ/crownWheelBlack.json": [
		94892,
		94892
	],
	"./en-NZ/crownWheelBlackLP.json": [
		42507,
		42507
	],
	"./en-NZ/cryptoExclusiveMay25LP.json": [
		63799,
		63799
	],
	"./en-NZ/cryptoOfferMay25LP.json": [
		12093,
		12093
	],
	"./en-NZ/deposits.json": [
		85985,
		85985
	],
	"./en-NZ/dialogs.json": [
		41843,
		41843
	],
	"./en-NZ/diceRoll.json": [
		89715,
		89715
	],
	"./en-NZ/dogTreasure.json": [
		97220,
		97220
	],
	"./en-NZ/dogTreasureTerms.json": [
		9607,
		9607
	],
	"./en-NZ/dragonLP.json": [
		2108,
		2108
	],
	"./en-NZ/dragonPearlsCoverflowLPTemplate.json": [
		55955,
		55955
	],
	"./en-NZ/dragonPearlsFebruary2026.json": [
		10747,
		10747
	],
	"./en-NZ/dragonPearlsMarch2026.json": [
		81155,
		81155
	],
	"./en-NZ/dragonPearlsNovember25LP.json": [
		41210,
		41210
	],
	"./en-NZ/easterApril2025.json": [
		23977,
		23977
	],
	"./en-NZ/easterApril2026.json": [
		22016,
		22016
	],
	"./en-NZ/easterMissions.json": [
		7422,
		7422
	],
	"./en-NZ/fiestaJune25LP.json": [
		4681,
		4681
	],
	"./en-NZ/fifa2026LP.json": [
		68375,
		68375
	],
	"./en-NZ/fruitCircusParty.json": [
		74103,
		74103
	],
	"./en-NZ/fruitsupMarch25.json": [
		70279,
		70279
	],
	"./en-NZ/gatesOfOlympusLP.json": [
		97545,
		97545
	],
	"./en-NZ/glossary.json": [
		39244,
		39244
	],
	"./en-NZ/halloween2026LP.json": [
		97252,
		97252
	],
	"./en-NZ/halloweenPromo26.json": [
		77671,
		77671
	],
	"./en-NZ/headlinePromo.json": [
		71770,
		71770
	],
	"./en-NZ/history.json": [
		87689,
		87689
	],
	"./en-NZ/jackpot.json": [
		28997,
		28997
	],
	"./en-NZ/juicyCarMay2025.json": [
		84146,
		84146
	],
	"./en-NZ/juicyMay.json": [
		21603,
		21603
	],
	"./en-NZ/kickupLP.json": [
		45725,
		45725
	],
	"./en-NZ/leaveDeposit.json": [
		91693,
		91693
	],
	"./en-NZ/leaveRegistration.json": [
		83030,
		83030
	],
	"./en-NZ/limits.json": [
		52187,
		52187
	],
	"./en-NZ/lobby.json": [
		93193,
		93193
	],
	"./en-NZ/lootboxes.json": [
		43834,
		43834
	],
	"./en-NZ/loyalty.json": [
		87922,
		87922
	],
	"./en-NZ/lpAssets.json": [
		77083,
		77083
	],
	"./en-NZ/lyzer40BanksBenefitsJune2025LP.json": [
		1068,
		1068
	],
	"./en-NZ/march2025.json": [
		88587,
		88587
	],
	"./en-NZ/matchlvlLP.json": [
		61792,
		61792
	],
	"./en-NZ/mission.json": [
		3624,
		3624
	],
	"./en-NZ/mobileApp.json": [
		86863,
		86863
	],
	"./en-NZ/mybeerLP.json": [
		14850,
		14850
	],
	"./en-NZ/odyssey-promo.json": [
		85597,
		85597
	],
	"./en-NZ/offerCardNovember2025LP.json": [
		51029,
		51029
	],
	"./en-NZ/oktoberfest.json": [
		65377,
		65377
	],
	"./en-NZ/personal.json": [
		96075,
		96075
	],
	"./en-NZ/profile.json": [
		36161,
		36161
	],
	"./en-NZ/promotions.json": [
		2295,
		2295
	],
	"./en-NZ/pumpkinKingdom.json": [
		16881,
		16881
	],
	"./en-NZ/quest.json": [
		96429,
		96429
	],
	"./en-NZ/redDragon3.json": [
		8336,
		8336
	],
	"./en-NZ/referralSystem.json": [
		67521,
		67521
	],
	"./en-NZ/regDragonRewards.json": [
		72591,
		72591
	],
	"./en-NZ/regDragonRewardsAugust25LP.json": [
		64206,
		64206
	],
	"./en-NZ/regDragonRewardsOctober25LP.json": [
		35311,
		35311
	],
	"./en-NZ/regDragonRewardsSports.json": [
		26878,
		26878
	],
	"./en-NZ/regRewards.json": [
		34289,
		34289
	],
	"./en-NZ/rewards.json": [
		5515,
		5515
	],
	"./en-NZ/royalupLP.json": [
		42701,
		42701
	],
	"./en-NZ/scoreupLP.json": [
		98198,
		98198
	],
	"./en-NZ/scratchGame.json": [
		40601,
		40601
	],
	"./en-NZ/security.json": [
		53158,
		53158
	],
	"./en-NZ/sharkJuly25LP.json": [
		27693,
		27693
	],
	"./en-NZ/slotsCircle.json": [
		62769,
		62769
	],
	"./en-NZ/slotsStepsAugust2025LP.json": [
		40080,
		40080
	],
	"./en-NZ/slotwinLP.json": [
		3215,
		3215
	],
	"./en-NZ/sportsDeposit.json": [
		41324,
		41324
	],
	"./en-NZ/sportslvlLP.json": [
		4088,
		4088
	],
	"./en-NZ/stPatrick2026.json": [
		66530,
		66530
	],
	"./en-NZ/sunOfEgypt.json": [
		28996,
		28996
	],
	"./en-NZ/support.json": [
		48133,
		48133
	],
	"./en-NZ/tournaments.json": [
		47693,
		47693
	],
	"./en-NZ/turbolvlJuly25LP.json": [
		6439,
		6439
	],
	"./en-NZ/validation.json": [
		41120,
		41120
	],
	"./en-NZ/verification.json": [
		46578,
		46578
	],
	"./en-NZ/vip.json": [
		92396,
		92396
	],
	"./en-NZ/vipGemCards.json": [
		20688,
		20688
	],
	"./en-NZ/welcomeApril2025.json": [
		33873,
		33873
	],
	"./en-NZ/welcomeSeptemberLP.json": [
		61572,
		61572
	],
	"./en-NZ/wheel.json": [
		48374,
		48374
	],
	"./en-NZ/wheelFortuneLP.json": [
		28250,
		28250
	],
	"./en-NZ/winterJanuary.json": [
		24727,
		24727
	],
	"./en-NZ/withdraw.json": [
		85890,
		85890
	],
	"./en-NZ/wolfElvisSunBuffalo.json": [
		11019,
		11019
	],
	"./en-NZ/wolfWheelLP.json": [
		42798,
		42798
	],
	"./en-NZ/worldcup2026LP.json": [
		6198,
		6198
	],
	"./en-NZ/xmasJanuary2026.json": [
		13571,
		13571
	],
	"./en-NZ/xmasbonusNovember2025LP.json": [
		92801,
		92801
	],
	"./en/50dragonLP.json": [
		60798,
		60798
	],
	"./en/50zillaOctober2025LP.json": [
		90082,
		90082
	],
	"./en/CardsBenefitsJune2025LP.json": [
		96117,
		96117
	],
	"./en/QuizBonusJune2025LP.json": [
		40128,
		40128
	],
	"./en/StValentine2026.json": [
		64674,
		64674
	],
	"./en/aviatorup.json": [
		94728,
		94728
	],
	"./en/banksBenefitsMay2025.json": [
		1291,
		1291
	],
	"./en/banksBenefitsOctober2025LP.json": [
		650,
		650
	],
	"./en/banksBenefitsSpooky2025LP.json": [
		43325,
		43325
	],
	"./en/becomeVip.json": [
		91900,
		91900
	],
	"./en/bigBass.json": [
		47780,
		47780
	],
	"./en/blackWheelLP.json": [
		21007,
		21007
	],
	"./en/bonanzaPromo.json": [
		881,
		881
	],
	"./en/bonusClaimLP.json": [
		40365,
		40365
	],
	"./en/bonusShop.json": [
		47332,
		47332
	],
	"./en/bonuses.json": [
		58045,
		58045
	],
	"./en/buffaloWheel.json": [
		13829,
		13829
	],
	"./en/cardsBenefitsAugust2025LP.json": [
		51962,
		51962
	],
	"./en/cardsBenefitsNovember2025LP.json": [
		56114,
		56114
	],
	"./en/carways2025LP.json": [
		97595,
		97595
	],
	"./en/cashbox.json": [
		25945,
		25945
	],
	"./en/cashupBonanza.json": [
		92372,
		92372
	],
	"./en/centredRegFormLP.json": [
		27565,
		94940
	],
	"./en/chickenupLP.json": [
		28539,
		28539
	],
	"./en/circleLP.json": [
		77388,
		77388
	],
	"./en/circusNovember.json": [
		69900,
		69900
	],
	"./en/coinupLP.json": [
		6500,
		6500
	],
	"./en/common.json": [
		30202,
		30202
	],
	"./en/crownApril25.json": [
		65958,
		43034
	],
	"./en/crownBanner.json": [
		68457,
		68457
	],
	"./en/crownMarch25.json": [
		14779,
		14779
	],
	"./en/crownWheelBlack.json": [
		13035,
		65871
	],
	"./en/crownWheelBlackLP.json": [
		6742,
		6742
	],
	"./en/cryptoExclusiveMay25LP.json": [
		44779,
		44779
	],
	"./en/cryptoOfferMay25LP.json": [
		67646,
		67646
	],
	"./en/deposits.json": [
		90536,
		90536
	],
	"./en/dialogs.json": [
		67896,
		22148
	],
	"./en/diceRoll.json": [
		67269,
		67269
	],
	"./en/dogTreasure.json": [
		49945,
		49945
	],
	"./en/dogTreasureTerms.json": [
		26080,
		26080
	],
	"./en/dragonLP.json": [
		9675,
		9675
	],
	"./en/dragonPearlsCoverflowLPTemplate.json": [
		20691,
		20691
	],
	"./en/dragonPearlsFebruary2026.json": [
		96666,
		96666
	],
	"./en/dragonPearlsMarch2026.json": [
		31878,
		31878
	],
	"./en/dragonPearlsNovember25LP.json": [
		75240,
		75240
	],
	"./en/easterApril2025.json": [
		4778,
		4778
	],
	"./en/easterApril2026.json": [
		88843,
		88843
	],
	"./en/easterMissions.json": [
		85274,
		85274
	],
	"./en/fiestaJune25LP.json": [
		64864,
		64864
	],
	"./en/fifa2026LP.json": [
		74555,
		34544
	],
	"./en/fruitCircusParty.json": [
		47509,
		47509
	],
	"./en/fruitsupMarch25.json": [
		7924,
		7924
	],
	"./en/gatesOfOlympusLP.json": [
		21199,
		21199
	],
	"./en/glossary.json": [
		3540,
		3540
	],
	"./en/halloween2026LP.json": [
		25885,
		25885
	],
	"./en/halloweenPromo26.json": [
		77566,
		77566
	],
	"./en/headlinePromo.json": [
		27110,
		27110
	],
	"./en/history.json": [
		58323,
		58323
	],
	"./en/jackpot.json": [
		45353,
		45353
	],
	"./en/juicyCarMay2025.json": [
		82646,
		82646
	],
	"./en/juicyMay.json": [
		54767,
		54767
	],
	"./en/kickupLP.json": [
		59757,
		59757
	],
	"./en/leaveDeposit.json": [
		62873,
		92312
	],
	"./en/leaveRegistration.json": [
		37607,
		37607
	],
	"./en/limits.json": [
		43683,
		43683
	],
	"./en/lobby.json": [
		90949,
		90949
	],
	"./en/lootboxes.json": [
		21285,
		21285
	],
	"./en/loyalty.json": [
		20590,
		20590
	],
	"./en/lpAssets.json": [
		340,
		340
	],
	"./en/lyzer40BanksBenefitsJune2025LP.json": [
		32290,
		32290
	],
	"./en/march2025.json": [
		52482,
		52482
	],
	"./en/matchlvlLP.json": [
		52829,
		52829
	],
	"./en/mission.json": [
		73660,
		73660
	],
	"./en/mobileApp.json": [
		90942,
		31767
	],
	"./en/mybeerLP.json": [
		96759,
		96759
	],
	"./en/odyssey-promo.json": [
		14289,
		14289
	],
	"./en/offerCardNovember2025LP.json": [
		99955,
		99955
	],
	"./en/oktoberfest.json": [
		91363,
		91363
	],
	"./en/personal.json": [
		35751,
		35751
	],
	"./en/profile.json": [
		48776,
		48776
	],
	"./en/promotions.json": [
		79033,
		79033
	],
	"./en/pumpkinKingdom.json": [
		1678,
		1678
	],
	"./en/quest.json": [
		73695,
		73695
	],
	"./en/redDragon3.json": [
		84194,
		84194
	],
	"./en/referralSystem.json": [
		74982,
		74982
	],
	"./en/regDragonRewards.json": [
		64763,
		64763
	],
	"./en/regDragonRewardsAugust25LP.json": [
		73300,
		73300
	],
	"./en/regDragonRewardsOctober25LP.json": [
		8955,
		8955
	],
	"./en/regDragonRewardsSports.json": [
		59619,
		59619
	],
	"./en/regRewards.json": [
		86955,
		86955
	],
	"./en/rewards.json": [
		54565,
		54565
	],
	"./en/royalupLP.json": [
		42297,
		42297
	],
	"./en/scoreupLP.json": [
		45844,
		45844
	],
	"./en/scratchGame.json": [
		15946,
		15946
	],
	"./en/security.json": [
		14138,
		14138
	],
	"./en/sharkJuly25LP.json": [
		87708,
		87708
	],
	"./en/slotsCircle.json": [
		60106,
		60106
	],
	"./en/slotsStepsAugust2025LP.json": [
		93518,
		93518
	],
	"./en/slotwinLP.json": [
		97993,
		97993
	],
	"./en/sportsDeposit.json": [
		62965,
		62965
	],
	"./en/sportslvlLP.json": [
		98697,
		98697
	],
	"./en/stPatrick2026.json": [
		41967,
		41967
	],
	"./en/sunOfEgypt.json": [
		87078,
		87078
	],
	"./en/support.json": [
		25030,
		25030
	],
	"./en/tournaments.json": [
		12506,
		12506
	],
	"./en/turbolvlJuly25LP.json": [
		47859,
		47859
	],
	"./en/validation.json": [
		25997,
		25997
	],
	"./en/verification.json": [
		55725,
		55725
	],
	"./en/vip.json": [
		17938,
		17938
	],
	"./en/vipGemCards.json": [
		13792,
		13792
	],
	"./en/welcomeApril2025.json": [
		75904,
		75904
	],
	"./en/welcomeSeptemberLP.json": [
		17874,
		17874
	],
	"./en/wheel.json": [
		85610,
		85610
	],
	"./en/wheelFortuneLP.json": [
		85039,
		85039
	],
	"./en/winterJanuary.json": [
		76642,
		76642
	],
	"./en/withdraw.json": [
		71883,
		71883
	],
	"./en/wolfElvisSunBuffalo.json": [
		73280,
		73280
	],
	"./en/wolfWheelLP.json": [
		24817,
		24817
	],
	"./en/worldcup2026LP.json": [
		69193,
		69193
	],
	"./en/xmasJanuary2026.json": [
		636,
		20815
	],
	"./en/xmasbonusNovember2025LP.json": [
		25796,
		25796
	],
	"./et-EE/50dragonLP.json": [
		12050,
		12050
	],
	"./et-EE/50zillaOctober2025LP.json": [
		29607,
		29607
	],
	"./et-EE/CardsBenefitsJune2025LP.json": [
		66673,
		66673
	],
	"./et-EE/QuizBonusJune2025LP.json": [
		9109,
		62873
	],
	"./et-EE/StValentine2026.json": [
		3575,
		3575
	],
	"./et-EE/aviatorup.json": [
		49951,
		49951
	],
	"./et-EE/banksBenefitsMay2025.json": [
		44808,
		44808
	],
	"./et-EE/banksBenefitsOctober2025LP.json": [
		19814,
		19814
	],
	"./et-EE/banksBenefitsSpooky2025LP.json": [
		43238,
		43238
	],
	"./et-EE/becomeVip.json": [
		46138,
		46138
	],
	"./et-EE/bigBass.json": [
		45933,
		45933
	],
	"./et-EE/blackWheelLP.json": [
		79964,
		79964
	],
	"./et-EE/bonanzaPromo.json": [
		75660,
		75660
	],
	"./et-EE/bonusClaimLP.json": [
		19644,
		19644
	],
	"./et-EE/bonusShop.json": [
		99724,
		99724
	],
	"./et-EE/bonuses.json": [
		21003,
		21003
	],
	"./et-EE/buffaloWheel.json": [
		85958,
		85958
	],
	"./et-EE/cardsBenefitsAugust2025LP.json": [
		21466,
		21466
	],
	"./et-EE/cardsBenefitsNovember2025LP.json": [
		53135,
		53135
	],
	"./et-EE/carways2025LP.json": [
		75820,
		75820
	],
	"./et-EE/cashbox.json": [
		49781,
		49781
	],
	"./et-EE/cashupBonanza.json": [
		73222,
		73222
	],
	"./et-EE/centredRegFormLP.json": [
		72857,
		72857
	],
	"./et-EE/chickenupLP.json": [
		37939,
		37939
	],
	"./et-EE/circleLP.json": [
		93599,
		93599
	],
	"./et-EE/circusNovember.json": [
		33488,
		33488
	],
	"./et-EE/coinupLP.json": [
		13630,
		13630
	],
	"./et-EE/common.json": [
		46223,
		46223
	],
	"./et-EE/crownApril25.json": [
		48903,
		48903
	],
	"./et-EE/crownBanner.json": [
		85371,
		85371
	],
	"./et-EE/crownMarch25.json": [
		65778,
		65778
	],
	"./et-EE/crownWheelBlack.json": [
		42851,
		42851
	],
	"./et-EE/crownWheelBlackLP.json": [
		55903,
		55903
	],
	"./et-EE/cryptoExclusiveMay25LP.json": [
		1817,
		1817
	],
	"./et-EE/cryptoOfferMay25LP.json": [
		51625,
		51625
	],
	"./et-EE/deposits.json": [
		59257,
		59257
	],
	"./et-EE/dialogs.json": [
		5803,
		5803
	],
	"./et-EE/diceRoll.json": [
		98831,
		98831
	],
	"./et-EE/dogTreasure.json": [
		15713,
		15713
	],
	"./et-EE/dogTreasureTerms.json": [
		91099,
		91099
	],
	"./et-EE/dragonLP.json": [
		18706,
		18706
	],
	"./et-EE/dragonPearlsCoverflowLPTemplate.json": [
		55724,
		55724
	],
	"./et-EE/dragonPearlsFebruary2026.json": [
		11705,
		11705
	],
	"./et-EE/dragonPearlsMarch2026.json": [
		88479,
		88479
	],
	"./et-EE/dragonPearlsNovember25LP.json": [
		47758,
		47758
	],
	"./et-EE/easterApril2025.json": [
		5813,
		5813
	],
	"./et-EE/easterApril2026.json": [
		18124,
		18124
	],
	"./et-EE/easterMissions.json": [
		6556,
		6556
	],
	"./et-EE/fiestaJune25LP.json": [
		58391,
		58391
	],
	"./et-EE/fifa2026LP.json": [
		60228,
		60228
	],
	"./et-EE/fruitCircusParty.json": [
		65503,
		65503
	],
	"./et-EE/fruitsupMarch25.json": [
		26364,
		26364
	],
	"./et-EE/gatesOfOlympusLP.json": [
		52679,
		52679
	],
	"./et-EE/glossary.json": [
		99803,
		99803
	],
	"./et-EE/halloween2026LP.json": [
		11001,
		11001
	],
	"./et-EE/halloweenPromo26.json": [
		66973,
		66973
	],
	"./et-EE/headlinePromo.json": [
		92181,
		92181
	],
	"./et-EE/history.json": [
		43049,
		43049
	],
	"./et-EE/jackpot.json": [
		55832,
		55832
	],
	"./et-EE/juicyCarMay2025.json": [
		4324,
		4324
	],
	"./et-EE/juicyMay.json": [
		68931,
		68931
	],
	"./et-EE/kickupLP.json": [
		19163,
		19163
	],
	"./et-EE/leaveDeposit.json": [
		89905,
		89905
	],
	"./et-EE/leaveRegistration.json": [
		43322,
		43322
	],
	"./et-EE/limits.json": [
		50971,
		50971
	],
	"./et-EE/lobby.json": [
		98518,
		98518
	],
	"./et-EE/lootboxes.json": [
		69319,
		69319
	],
	"./et-EE/loyalty.json": [
		23123,
		23123
	],
	"./et-EE/lpAssets.json": [
		27604,
		27604
	],
	"./et-EE/lyzer40BanksBenefitsJune2025LP.json": [
		95893,
		95893
	],
	"./et-EE/march2025.json": [
		10525,
		10525
	],
	"./et-EE/matchlvlLP.json": [
		23389,
		23389
	],
	"./et-EE/mission.json": [
		5504,
		5504
	],
	"./et-EE/mobileApp.json": [
		77411,
		77411
	],
	"./et-EE/mybeerLP.json": [
		23335,
		23335
	],
	"./et-EE/odyssey-promo.json": [
		22473,
		22473
	],
	"./et-EE/offerCardNovember2025LP.json": [
		52516,
		52516
	],
	"./et-EE/oktoberfest.json": [
		23116,
		23116
	],
	"./et-EE/personal.json": [
		4447,
		4447
	],
	"./et-EE/profile.json": [
		94289,
		94289
	],
	"./et-EE/promotions.json": [
		62412,
		62412
	],
	"./et-EE/pumpkinKingdom.json": [
		80997,
		80997
	],
	"./et-EE/quest.json": [
		55864,
		55864
	],
	"./et-EE/redDragon3.json": [
		91113,
		91113
	],
	"./et-EE/referralSystem.json": [
		33816,
		33816
	],
	"./et-EE/regDragonRewards.json": [
		35821,
		90483
	],
	"./et-EE/regDragonRewardsAugust25LP.json": [
		31909,
		31909
	],
	"./et-EE/regDragonRewardsOctober25LP.json": [
		71460,
		71460
	],
	"./et-EE/regDragonRewardsSports.json": [
		47588,
		47588
	],
	"./et-EE/regRewards.json": [
		53293,
		53293
	],
	"./et-EE/rewards.json": [
		3436,
		3436
	],
	"./et-EE/royalupLP.json": [
		85484,
		85484
	],
	"./et-EE/scoreupLP.json": [
		11150,
		11150
	],
	"./et-EE/scratchGame.json": [
		23396,
		23396
	],
	"./et-EE/security.json": [
		92499,
		92499
	],
	"./et-EE/sharkJuly25LP.json": [
		21088,
		21088
	],
	"./et-EE/slotsCircle.json": [
		5736,
		5736
	],
	"./et-EE/slotsStepsAugust2025LP.json": [
		99818,
		99818
	],
	"./et-EE/slotwinLP.json": [
		68550,
		68550
	],
	"./et-EE/sportsDeposit.json": [
		6774,
		6774
	],
	"./et-EE/sportslvlLP.json": [
		74878,
		58780
	],
	"./et-EE/stPatrick2026.json": [
		8918,
		8918
	],
	"./et-EE/sunOfEgypt.json": [
		26643,
		26643
	],
	"./et-EE/support.json": [
		80157,
		80157
	],
	"./et-EE/tournaments.json": [
		71913,
		71913
	],
	"./et-EE/turbolvlJuly25LP.json": [
		27946,
		27946
	],
	"./et-EE/validation.json": [
		98590,
		98590
	],
	"./et-EE/verification.json": [
		12776,
		12776
	],
	"./et-EE/vip.json": [
		45184,
		45184
	],
	"./et-EE/vipGemCards.json": [
		2123,
		2123
	],
	"./et-EE/welcomeApril2025.json": [
		55344,
		55344
	],
	"./et-EE/welcomeSeptemberLP.json": [
		48499,
		48499
	],
	"./et-EE/wheel.json": [
		40448,
		40448
	],
	"./et-EE/wheelFortuneLP.json": [
		28073,
		28073
	],
	"./et-EE/winterJanuary.json": [
		82100,
		82100
	],
	"./et-EE/withdraw.json": [
		28330,
		28330
	],
	"./et-EE/wolfElvisSunBuffalo.json": [
		79471,
		79471
	],
	"./et-EE/wolfWheelLP.json": [
		77210,
		77210
	],
	"./et-EE/worldcup2026LP.json": [
		49005,
		49005
	],
	"./et-EE/xmasJanuary2026.json": [
		2414,
		2414
	],
	"./et-EE/xmasbonusNovember2025LP.json": [
		59356,
		59356
	],
	"./fi/50dragonLP.json": [
		36941,
		36941
	],
	"./fi/50zillaOctober2025LP.json": [
		32028,
		32028
	],
	"./fi/CardsBenefitsJune2025LP.json": [
		52263,
		52263
	],
	"./fi/QuizBonusJune2025LP.json": [
		73597,
		73597
	],
	"./fi/StValentine2026.json": [
		26274,
		26274
	],
	"./fi/aviatorup.json": [
		93021,
		93021
	],
	"./fi/banksBenefitsMay2025.json": [
		47338,
		47338
	],
	"./fi/banksBenefitsOctober2025LP.json": [
		78231,
		78231
	],
	"./fi/banksBenefitsSpooky2025LP.json": [
		81001,
		81001
	],
	"./fi/becomeVip.json": [
		34573,
		34573
	],
	"./fi/bigBass.json": [
		31503,
		31503
	],
	"./fi/blackWheelLP.json": [
		18336,
		18336
	],
	"./fi/bonanzaPromo.json": [
		7568,
		7568
	],
	"./fi/bonusClaimLP.json": [
		97573,
		97573
	],
	"./fi/bonusShop.json": [
		85243,
		85243
	],
	"./fi/bonuses.json": [
		12197,
		12197
	],
	"./fi/buffaloWheel.json": [
		46629,
		46629
	],
	"./fi/cardsBenefitsAugust2025LP.json": [
		16804,
		16804
	],
	"./fi/cardsBenefitsNovember2025LP.json": [
		63512,
		63512
	],
	"./fi/carways2025LP.json": [
		83980,
		83980
	],
	"./fi/cashbox.json": [
		14558,
		14558
	],
	"./fi/cashupBonanza.json": [
		91122,
		91122
	],
	"./fi/centredRegFormLP.json": [
		85231,
		85231
	],
	"./fi/chickenupLP.json": [
		99692,
		99692
	],
	"./fi/circleLP.json": [
		4250,
		4250
	],
	"./fi/circusNovember.json": [
		85436,
		67627
	],
	"./fi/coinupLP.json": [
		44741,
		44741
	],
	"./fi/common.json": [
		74582,
		74582
	],
	"./fi/crownApril25.json": [
		92608,
		92608
	],
	"./fi/crownBanner.json": [
		75473,
		75473
	],
	"./fi/crownMarch25.json": [
		11121,
		11121
	],
	"./fi/crownWheelBlack.json": [
		13405,
		13405
	],
	"./fi/crownWheelBlackLP.json": [
		64079,
		64079
	],
	"./fi/cryptoExclusiveMay25LP.json": [
		32902,
		32902
	],
	"./fi/cryptoOfferMay25LP.json": [
		39986,
		39986
	],
	"./fi/deposits.json": [
		51387,
		51387
	],
	"./fi/dialogs.json": [
		27015,
		27015
	],
	"./fi/diceRoll.json": [
		40376,
		40376
	],
	"./fi/dogTreasure.json": [
		41628,
		41628
	],
	"./fi/dogTreasureTerms.json": [
		96768,
		96768
	],
	"./fi/dragonLP.json": [
		41515,
		41515
	],
	"./fi/dragonPearlsCoverflowLPTemplate.json": [
		47980,
		47980
	],
	"./fi/dragonPearlsFebruary2026.json": [
		6358,
		6358
	],
	"./fi/dragonPearlsMarch2026.json": [
		62312,
		62312
	],
	"./fi/dragonPearlsNovember25LP.json": [
		97405,
		97405
	],
	"./fi/easterApril2025.json": [
		25283,
		25283
	],
	"./fi/easterApril2026.json": [
		94548,
		94548
	],
	"./fi/easterMissions.json": [
		46088,
		46088
	],
	"./fi/fiestaJune25LP.json": [
		24904,
		24904
	],
	"./fi/fifa2026LP.json": [
		76999,
		76999
	],
	"./fi/fruitCircusParty.json": [
		23497,
		23497
	],
	"./fi/fruitsupMarch25.json": [
		14697,
		14697
	],
	"./fi/gatesOfOlympusLP.json": [
		18609,
		18609
	],
	"./fi/glossary.json": [
		295,
		295
	],
	"./fi/halloween2026LP.json": [
		17340,
		17340
	],
	"./fi/halloweenPromo26.json": [
		57884,
		57884
	],
	"./fi/headlinePromo.json": [
		87703,
		87703
	],
	"./fi/history.json": [
		12258,
		12258
	],
	"./fi/jackpot.json": [
		86527,
		37160
	],
	"./fi/juicyCarMay2025.json": [
		82872,
		82872
	],
	"./fi/juicyMay.json": [
		47066,
		47066
	],
	"./fi/kickupLP.json": [
		3981,
		3981
	],
	"./fi/leaveDeposit.json": [
		40566,
		40566
	],
	"./fi/leaveRegistration.json": [
		31729,
		31729
	],
	"./fi/limits.json": [
		66775,
		66775
	],
	"./fi/lobby.json": [
		95512,
		95512
	],
	"./fi/lootboxes.json": [
		67190,
		67190
	],
	"./fi/loyalty.json": [
		20249,
		20249
	],
	"./fi/lpAssets.json": [
		12728,
		12728
	],
	"./fi/lyzer40BanksBenefitsJune2025LP.json": [
		9870,
		9870
	],
	"./fi/march2025.json": [
		90179,
		90179
	],
	"./fi/matchlvlLP.json": [
		53364,
		53364
	],
	"./fi/mission.json": [
		26804,
		26804
	],
	"./fi/mobileApp.json": [
		56825,
		56825
	],
	"./fi/mybeerLP.json": [
		1589,
		1589
	],
	"./fi/odyssey-promo.json": [
		93380,
		93380
	],
	"./fi/offerCardNovember2025LP.json": [
		72374,
		72374
	],
	"./fi/oktoberfest.json": [
		16785,
		16785
	],
	"./fi/personal.json": [
		26733,
		26733
	],
	"./fi/profile.json": [
		30193,
		30193
	],
	"./fi/promotions.json": [
		14273,
		14273
	],
	"./fi/pumpkinKingdom.json": [
		8139,
		8139
	],
	"./fi/quest.json": [
		26018,
		26018
	],
	"./fi/redDragon3.json": [
		62794,
		62794
	],
	"./fi/referralSystem.json": [
		67029,
		67029
	],
	"./fi/regDragonRewards.json": [
		23783,
		23783
	],
	"./fi/regDragonRewardsAugust25LP.json": [
		35955,
		35955
	],
	"./fi/regDragonRewardsOctober25LP.json": [
		12014,
		12014
	],
	"./fi/regDragonRewardsSports.json": [
		5650,
		5650
	],
	"./fi/regRewards.json": [
		31759,
		31759
	],
	"./fi/rewards.json": [
		32574,
		32574
	],
	"./fi/royalupLP.json": [
		86804,
		87113
	],
	"./fi/scoreupLP.json": [
		9493,
		9493
	],
	"./fi/scratchGame.json": [
		30462,
		30462
	],
	"./fi/security.json": [
		55063,
		55063
	],
	"./fi/sharkJuly25LP.json": [
		71657,
		71657
	],
	"./fi/slotsCircle.json": [
		94521,
		94521
	],
	"./fi/slotsStepsAugust2025LP.json": [
		49722,
		49722
	],
	"./fi/slotwinLP.json": [
		97767,
		97767
	],
	"./fi/sportsDeposit.json": [
		54650,
		54650
	],
	"./fi/sportslvlLP.json": [
		73409,
		73409
	],
	"./fi/stPatrick2026.json": [
		53065,
		53065
	],
	"./fi/sunOfEgypt.json": [
		83626,
		83626
	],
	"./fi/support.json": [
		16426,
		16426
	],
	"./fi/tournaments.json": [
		67517,
		67517
	],
	"./fi/turbolvlJuly25LP.json": [
		43986,
		43986
	],
	"./fi/validation.json": [
		88078,
		88078
	],
	"./fi/verification.json": [
		54543,
		54543
	],
	"./fi/vip.json": [
		21290,
		21290
	],
	"./fi/vipGemCards.json": [
		87280,
		87280
	],
	"./fi/welcomeApril2025.json": [
		28720,
		28720
	],
	"./fi/welcomeSeptemberLP.json": [
		62097,
		62097
	],
	"./fi/wheel.json": [
		2553,
		2553
	],
	"./fi/wheelFortuneLP.json": [
		14407,
		14407
	],
	"./fi/winterJanuary.json": [
		82727,
		82727
	],
	"./fi/withdraw.json": [
		20376,
		20376
	],
	"./fi/wolfElvisSunBuffalo.json": [
		22269,
		22269
	],
	"./fi/wolfWheelLP.json": [
		78169,
		78169
	],
	"./fi/worldcup2026LP.json": [
		41244,
		41244
	],
	"./fi/xmasJanuary2026.json": [
		98431,
		98431
	],
	"./fi/xmasbonusNovember2025LP.json": [
		5437,
		5437
	],
	"./fr-CA/50dragonLP.json": [
		105,
		105
	],
	"./fr-CA/50zillaOctober2025LP.json": [
		60809,
		60809
	],
	"./fr-CA/CardsBenefitsJune2025LP.json": [
		76666,
		76666
	],
	"./fr-CA/QuizBonusJune2025LP.json": [
		79486,
		79486
	],
	"./fr-CA/StValentine2026.json": [
		28205,
		28205
	],
	"./fr-CA/aviatorup.json": [
		11049,
		11049
	],
	"./fr-CA/banksBenefitsMay2025.json": [
		12886,
		12886
	],
	"./fr-CA/banksBenefitsOctober2025LP.json": [
		95940,
		95940
	],
	"./fr-CA/banksBenefitsSpooky2025LP.json": [
		55397,
		55397
	],
	"./fr-CA/becomeVip.json": [
		78902,
		78902
	],
	"./fr-CA/bigBass.json": [
		4062,
		4062
	],
	"./fr-CA/blackWheelLP.json": [
		78956,
		78956
	],
	"./fr-CA/bonanzaPromo.json": [
		81121,
		81121
	],
	"./fr-CA/bonusClaimLP.json": [
		64136,
		64136
	],
	"./fr-CA/bonusShop.json": [
		85702,
		85702
	],
	"./fr-CA/bonuses.json": [
		90869,
		90869
	],
	"./fr-CA/buffaloWheel.json": [
		4705,
		4705
	],
	"./fr-CA/cardsBenefitsAugust2025LP.json": [
		38548,
		38548
	],
	"./fr-CA/cardsBenefitsNovember2025LP.json": [
		88566,
		88566
	],
	"./fr-CA/carways2025LP.json": [
		3642,
		3642
	],
	"./fr-CA/cashbox.json": [
		596,
		596
	],
	"./fr-CA/cashupBonanza.json": [
		69938,
		69938
	],
	"./fr-CA/centredRegFormLP.json": [
		37522,
		37522
	],
	"./fr-CA/chickenupLP.json": [
		7966,
		7966
	],
	"./fr-CA/circleLP.json": [
		63196,
		63196
	],
	"./fr-CA/circusNovember.json": [
		83858,
		83858
	],
	"./fr-CA/coinupLP.json": [
		88447,
		88447
	],
	"./fr-CA/common.json": [
		73577,
		73577
	],
	"./fr-CA/crownApril25.json": [
		26307,
		26307
	],
	"./fr-CA/crownBanner.json": [
		26761,
		26761
	],
	"./fr-CA/crownMarch25.json": [
		84444,
		84444
	],
	"./fr-CA/crownWheelBlack.json": [
		27788,
		27788
	],
	"./fr-CA/crownWheelBlackLP.json": [
		225,
		225
	],
	"./fr-CA/cryptoExclusiveMay25LP.json": [
		40669,
		40669
	],
	"./fr-CA/cryptoOfferMay25LP.json": [
		63564,
		63564
	],
	"./fr-CA/deposits.json": [
		32549,
		32549
	],
	"./fr-CA/dialogs.json": [
		7927,
		7927
	],
	"./fr-CA/diceRoll.json": [
		14338,
		14338
	],
	"./fr-CA/dogTreasure.json": [
		29447,
		29447
	],
	"./fr-CA/dogTreasureTerms.json": [
		74264,
		74264
	],
	"./fr-CA/dragonLP.json": [
		36343,
		36343
	],
	"./fr-CA/dragonPearlsCoverflowLPTemplate.json": [
		32032,
		32032
	],
	"./fr-CA/dragonPearlsFebruary2026.json": [
		96785,
		96785
	],
	"./fr-CA/dragonPearlsMarch2026.json": [
		62565,
		62565
	],
	"./fr-CA/dragonPearlsNovember25LP.json": [
		55719,
		55719
	],
	"./fr-CA/easterApril2025.json": [
		98005,
		98005
	],
	"./fr-CA/easterApril2026.json": [
		65801,
		65801
	],
	"./fr-CA/easterMissions.json": [
		97446,
		97446
	],
	"./fr-CA/fiestaJune25LP.json": [
		65270,
		65270
	],
	"./fr-CA/fifa2026LP.json": [
		48118,
		48118
	],
	"./fr-CA/fruitCircusParty.json": [
		93168,
		93168
	],
	"./fr-CA/fruitsupMarch25.json": [
		95603,
		95603
	],
	"./fr-CA/gatesOfOlympusLP.json": [
		90694,
		90694
	],
	"./fr-CA/glossary.json": [
		1751,
		1751
	],
	"./fr-CA/halloween2026LP.json": [
		91827,
		91827
	],
	"./fr-CA/halloweenPromo26.json": [
		54390,
		54390
	],
	"./fr-CA/headlinePromo.json": [
		7618,
		7618
	],
	"./fr-CA/history.json": [
		9676,
		9676
	],
	"./fr-CA/jackpot.json": [
		94793,
		94793
	],
	"./fr-CA/juicyCarMay2025.json": [
		62664,
		62664
	],
	"./fr-CA/juicyMay.json": [
		87437,
		87437
	],
	"./fr-CA/kickupLP.json": [
		48486,
		48486
	],
	"./fr-CA/leaveDeposit.json": [
		84580,
		84580
	],
	"./fr-CA/leaveRegistration.json": [
		98814,
		98814
	],
	"./fr-CA/limits.json": [
		40061,
		40061
	],
	"./fr-CA/lobby.json": [
		19592,
		19592
	],
	"./fr-CA/lootboxes.json": [
		61980,
		61980
	],
	"./fr-CA/loyalty.json": [
		94150,
		94150
	],
	"./fr-CA/lpAssets.json": [
		97906,
		97906
	],
	"./fr-CA/lyzer40BanksBenefitsJune2025LP.json": [
		42594,
		42594
	],
	"./fr-CA/march2025.json": [
		74698,
		74698
	],
	"./fr-CA/matchlvlLP.json": [
		73046,
		73046
	],
	"./fr-CA/mission.json": [
		96621,
		96621
	],
	"./fr-CA/mobileApp.json": [
		28739,
		28739
	],
	"./fr-CA/mybeerLP.json": [
		64907,
		64907
	],
	"./fr-CA/odyssey-promo.json": [
		18666,
		18666
	],
	"./fr-CA/offerCardNovember2025LP.json": [
		73810,
		73810
	],
	"./fr-CA/oktoberfest.json": [
		36788,
		36788
	],
	"./fr-CA/personal.json": [
		13924,
		13924
	],
	"./fr-CA/profile.json": [
		85792,
		85792
	],
	"./fr-CA/promotions.json": [
		45614,
		45614
	],
	"./fr-CA/pumpkinKingdom.json": [
		67930,
		67930
	],
	"./fr-CA/quest.json": [
		64650,
		64650
	],
	"./fr-CA/redDragon3.json": [
		75827,
		75827
	],
	"./fr-CA/referralSystem.json": [
		46683,
		46683
	],
	"./fr-CA/regDragonRewards.json": [
		38833,
		38833
	],
	"./fr-CA/regDragonRewardsAugust25LP.json": [
		27439,
		27439
	],
	"./fr-CA/regDragonRewardsOctober25LP.json": [
		82278,
		82278
	],
	"./fr-CA/regDragonRewardsSports.json": [
		41592,
		41592
	],
	"./fr-CA/regRewards.json": [
		55203,
		55203
	],
	"./fr-CA/rewards.json": [
		68289,
		68289
	],
	"./fr-CA/royalupLP.json": [
		52169,
		52169
	],
	"./fr-CA/scoreupLP.json": [
		32876,
		32876
	],
	"./fr-CA/scratchGame.json": [
		23772,
		23772
	],
	"./fr-CA/security.json": [
		68984,
		68984
	],
	"./fr-CA/sharkJuly25LP.json": [
		99272,
		99272
	],
	"./fr-CA/slotsCircle.json": [
		65789,
		65789
	],
	"./fr-CA/slotsStepsAugust2025LP.json": [
		13272,
		13272
	],
	"./fr-CA/slotwinLP.json": [
		70969,
		70969
	],
	"./fr-CA/sportsDeposit.json": [
		39361,
		39361
	],
	"./fr-CA/sportslvlLP.json": [
		25171,
		25171
	],
	"./fr-CA/stPatrick2026.json": [
		6401,
		6401
	],
	"./fr-CA/sunOfEgypt.json": [
		53744,
		53744
	],
	"./fr-CA/support.json": [
		47359,
		47359
	],
	"./fr-CA/tournaments.json": [
		36691,
		36691
	],
	"./fr-CA/turbolvlJuly25LP.json": [
		85615,
		85615
	],
	"./fr-CA/validation.json": [
		50555,
		50555
	],
	"./fr-CA/verification.json": [
		72772,
		72772
	],
	"./fr-CA/vip.json": [
		65086,
		65086
	],
	"./fr-CA/vipGemCards.json": [
		20556,
		20556
	],
	"./fr-CA/welcomeApril2025.json": [
		52650,
		52650
	],
	"./fr-CA/welcomeSeptemberLP.json": [
		15370,
		15370
	],
	"./fr-CA/wheel.json": [
		65588,
		65588
	],
	"./fr-CA/wheelFortuneLP.json": [
		73734,
		73734
	],
	"./fr-CA/winterJanuary.json": [
		63910,
		63910
	],
	"./fr-CA/withdraw.json": [
		53445,
		53445
	],
	"./fr-CA/wolfElvisSunBuffalo.json": [
		98927,
		98927
	],
	"./fr-CA/wolfWheelLP.json": [
		82524,
		82524
	],
	"./fr-CA/worldcup2026LP.json": [
		25563,
		25563
	],
	"./fr-CA/xmasJanuary2026.json": [
		91029,
		91029
	],
	"./fr-CA/xmasbonusNovember2025LP.json": [
		74885,
		74885
	],
	"./fr-CH/50dragonLP.json": [
		61129,
		61129
	],
	"./fr-CH/50zillaOctober2025LP.json": [
		78254,
		78254
	],
	"./fr-CH/CardsBenefitsJune2025LP.json": [
		50021,
		50021
	],
	"./fr-CH/QuizBonusJune2025LP.json": [
		17517,
		17517
	],
	"./fr-CH/StValentine2026.json": [
		85907,
		85907
	],
	"./fr-CH/aviatorup.json": [
		39959,
		39959
	],
	"./fr-CH/banksBenefitsMay2025.json": [
		89047,
		89047
	],
	"./fr-CH/banksBenefitsOctober2025LP.json": [
		90937,
		90937
	],
	"./fr-CH/banksBenefitsSpooky2025LP.json": [
		65378,
		65378
	],
	"./fr-CH/becomeVip.json": [
		37097,
		37097
	],
	"./fr-CH/bigBass.json": [
		67464,
		13035
	],
	"./fr-CH/blackWheelLP.json": [
		18727,
		18727
	],
	"./fr-CH/bonanzaPromo.json": [
		19267,
		19267
	],
	"./fr-CH/bonusClaimLP.json": [
		49202,
		49202
	],
	"./fr-CH/bonusShop.json": [
		17176,
		17176
	],
	"./fr-CH/bonuses.json": [
		4866,
		4866
	],
	"./fr-CH/buffaloWheel.json": [
		94771,
		94771
	],
	"./fr-CH/cardsBenefitsAugust2025LP.json": [
		70807,
		70807
	],
	"./fr-CH/cardsBenefitsNovember2025LP.json": [
		22575,
		22575
	],
	"./fr-CH/carways2025LP.json": [
		65250,
		65250
	],
	"./fr-CH/cashbox.json": [
		43481,
		43481
	],
	"./fr-CH/cashupBonanza.json": [
		53489,
		53489
	],
	"./fr-CH/centredRegFormLP.json": [
		26196,
		26196
	],
	"./fr-CH/chickenupLP.json": [
		35171,
		35171
	],
	"./fr-CH/circleLP.json": [
		87048,
		87048
	],
	"./fr-CH/circusNovember.json": [
		81792,
		81792
	],
	"./fr-CH/coinupLP.json": [
		53100,
		53100
	],
	"./fr-CH/common.json": [
		97794,
		97794
	],
	"./fr-CH/crownApril25.json": [
		77200,
		77200
	],
	"./fr-CH/crownBanner.json": [
		21460,
		21460
	],
	"./fr-CH/crownMarch25.json": [
		26275,
		26275
	],
	"./fr-CH/crownWheelBlack.json": [
		64919,
		14929
	],
	"./fr-CH/crownWheelBlackLP.json": [
		44868,
		44868
	],
	"./fr-CH/cryptoExclusiveMay25LP.json": [
		89781,
		89781
	],
	"./fr-CH/cryptoOfferMay25LP.json": [
		8392,
		8392
	],
	"./fr-CH/deposits.json": [
		42846,
		42846
	],
	"./fr-CH/dialogs.json": [
		38665,
		38665
	],
	"./fr-CH/diceRoll.json": [
		94986,
		94986
	],
	"./fr-CH/dogTreasure.json": [
		59931,
		59931
	],
	"./fr-CH/dogTreasureTerms.json": [
		10096,
		10096
	],
	"./fr-CH/dragonLP.json": [
		63083,
		63083
	],
	"./fr-CH/dragonPearlsCoverflowLPTemplate.json": [
		64891,
		64891
	],
	"./fr-CH/dragonPearlsFebruary2026.json": [
		6989,
		6989
	],
	"./fr-CH/dragonPearlsMarch2026.json": [
		32133,
		32133
	],
	"./fr-CH/dragonPearlsNovember25LP.json": [
		39218,
		12892
	],
	"./fr-CH/easterApril2025.json": [
		54366,
		54366
	],
	"./fr-CH/easterApril2026.json": [
		78990,
		78990
	],
	"./fr-CH/easterMissions.json": [
		37250,
		37250
	],
	"./fr-CH/fiestaJune25LP.json": [
		75897,
		75897
	],
	"./fr-CH/fifa2026LP.json": [
		63286,
		63286
	],
	"./fr-CH/fruitCircusParty.json": [
		60156,
		60156
	],
	"./fr-CH/fruitsupMarch25.json": [
		20321,
		20321
	],
	"./fr-CH/gatesOfOlympusLP.json": [
		53139,
		53139
	],
	"./fr-CH/glossary.json": [
		60055,
		60055
	],
	"./fr-CH/halloween2026LP.json": [
		31883,
		31883
	],
	"./fr-CH/halloweenPromo26.json": [
		19637,
		19637
	],
	"./fr-CH/headlinePromo.json": [
		77818,
		77818
	],
	"./fr-CH/history.json": [
		4127,
		4127
	],
	"./fr-CH/jackpot.json": [
		12469,
		12469
	],
	"./fr-CH/juicyCarMay2025.json": [
		15741,
		15741
	],
	"./fr-CH/juicyMay.json": [
		67907,
		67907
	],
	"./fr-CH/kickupLP.json": [
		94676,
		94676
	],
	"./fr-CH/leaveDeposit.json": [
		7823,
		7823
	],
	"./fr-CH/leaveRegistration.json": [
		85884,
		85884
	],
	"./fr-CH/limits.json": [
		15053,
		15053
	],
	"./fr-CH/lobby.json": [
		94422,
		94422
	],
	"./fr-CH/lootboxes.json": [
		36136,
		36136
	],
	"./fr-CH/loyalty.json": [
		10188,
		10188
	],
	"./fr-CH/lpAssets.json": [
		83721,
		83721
	],
	"./fr-CH/lyzer40BanksBenefitsJune2025LP.json": [
		44225,
		44225
	],
	"./fr-CH/march2025.json": [
		55029,
		55029
	],
	"./fr-CH/matchlvlLP.json": [
		59406,
		59406
	],
	"./fr-CH/mission.json": [
		13510,
		13510
	],
	"./fr-CH/mobileApp.json": [
		13873,
		13873
	],
	"./fr-CH/mybeerLP.json": [
		65346,
		65346
	],
	"./fr-CH/odyssey-promo.json": [
		99457,
		99457
	],
	"./fr-CH/offerCardNovember2025LP.json": [
		5258,
		5258
	],
	"./fr-CH/oktoberfest.json": [
		70801,
		70801
	],
	"./fr-CH/personal.json": [
		24850,
		24850
	],
	"./fr-CH/profile.json": [
		56151,
		56151
	],
	"./fr-CH/promotions.json": [
		57166,
		57166
	],
	"./fr-CH/pumpkinKingdom.json": [
		50471,
		50471
	],
	"./fr-CH/quest.json": [
		12908,
		12908
	],
	"./fr-CH/redDragon3.json": [
		66972,
		66972
	],
	"./fr-CH/referralSystem.json": [
		98338,
		98338
	],
	"./fr-CH/regDragonRewards.json": [
		35631,
		35631
	],
	"./fr-CH/regDragonRewardsAugust25LP.json": [
		82926,
		82926
	],
	"./fr-CH/regDragonRewardsOctober25LP.json": [
		26851,
		26851
	],
	"./fr-CH/regDragonRewardsSports.json": [
		42291,
		42291
	],
	"./fr-CH/regRewards.json": [
		77997,
		77997
	],
	"./fr-CH/rewards.json": [
		54062,
		54062
	],
	"./fr-CH/royalupLP.json": [
		2041,
		2041
	],
	"./fr-CH/scoreupLP.json": [
		73836,
		73836
	],
	"./fr-CH/scratchGame.json": [
		95727,
		95727
	],
	"./fr-CH/security.json": [
		39776,
		39776
	],
	"./fr-CH/sharkJuly25LP.json": [
		93405,
		93405
	],
	"./fr-CH/slotsCircle.json": [
		35534,
		35534
	],
	"./fr-CH/slotsStepsAugust2025LP.json": [
		11564,
		11564
	],
	"./fr-CH/slotwinLP.json": [
		77075,
		77075
	],
	"./fr-CH/sportsDeposit.json": [
		8764,
		71195
	],
	"./fr-CH/sportslvlLP.json": [
		69196,
		69196
	],
	"./fr-CH/stPatrick2026.json": [
		9901,
		9901
	],
	"./fr-CH/sunOfEgypt.json": [
		35480,
		35480
	],
	"./fr-CH/support.json": [
		44566,
		44566
	],
	"./fr-CH/tournaments.json": [
		47508,
		47508
	],
	"./fr-CH/turbolvlJuly25LP.json": [
		56939,
		56939
	],
	"./fr-CH/validation.json": [
		49537,
		49537
	],
	"./fr-CH/verification.json": [
		19342,
		19342
	],
	"./fr-CH/vip.json": [
		65782,
		65782
	],
	"./fr-CH/vipGemCards.json": [
		64576,
		64576
	],
	"./fr-CH/welcomeApril2025.json": [
		17497,
		17497
	],
	"./fr-CH/welcomeSeptemberLP.json": [
		74569,
		74569
	],
	"./fr-CH/wheel.json": [
		83643,
		83643
	],
	"./fr-CH/wheelFortuneLP.json": [
		20532,
		20532
	],
	"./fr-CH/winterJanuary.json": [
		15276,
		15276
	],
	"./fr-CH/withdraw.json": [
		90547,
		90547
	],
	"./fr-CH/wolfElvisSunBuffalo.json": [
		10853,
		10853
	],
	"./fr-CH/wolfWheelLP.json": [
		55324,
		55324
	],
	"./fr-CH/worldcup2026LP.json": [
		17009,
		17009
	],
	"./fr-CH/xmasJanuary2026.json": [
		74643,
		74643
	],
	"./fr-CH/xmasbonusNovember2025LP.json": [
		57537,
		57537
	],
	"./no/50dragonLP.json": [
		98278,
		98278
	],
	"./no/50zillaOctober2025LP.json": [
		27250,
		27250
	],
	"./no/CardsBenefitsJune2025LP.json": [
		70640,
		70640
	],
	"./no/QuizBonusJune2025LP.json": [
		36143,
		36143
	],
	"./no/StValentine2026.json": [
		64390,
		64390
	],
	"./no/aviatorup.json": [
		74307,
		74307
	],
	"./no/banksBenefitsMay2025.json": [
		67891,
		67891
	],
	"./no/banksBenefitsOctober2025LP.json": [
		65622,
		65622
	],
	"./no/banksBenefitsSpooky2025LP.json": [
		41345,
		41345
	],
	"./no/becomeVip.json": [
		42864,
		42864
	],
	"./no/bigBass.json": [
		86243,
		86243
	],
	"./no/blackWheelLP.json": [
		84871,
		84871
	],
	"./no/bonanzaPromo.json": [
		85329,
		85329
	],
	"./no/bonusClaimLP.json": [
		57646,
		57646
	],
	"./no/bonusShop.json": [
		61896,
		61896
	],
	"./no/bonuses.json": [
		68552,
		68552
	],
	"./no/buffaloWheel.json": [
		96108,
		96108
	],
	"./no/cardsBenefitsAugust2025LP.json": [
		88903,
		88903
	],
	"./no/cardsBenefitsNovember2025LP.json": [
		36218,
		36218
	],
	"./no/carways2025LP.json": [
		55189,
		86804
	],
	"./no/cashbox.json": [
		47683,
		47683
	],
	"./no/cashupBonanza.json": [
		86621,
		86621
	],
	"./no/centredRegFormLP.json": [
		78018,
		78018
	],
	"./no/chickenupLP.json": [
		69220,
		69220
	],
	"./no/circleLP.json": [
		98269,
		98269
	],
	"./no/circusNovember.json": [
		10074,
		10074
	],
	"./no/coinupLP.json": [
		11357,
		11357
	],
	"./no/common.json": [
		28363,
		28363
	],
	"./no/crownApril25.json": [
		85834,
		85834
	],
	"./no/crownBanner.json": [
		43455,
		43455
	],
	"./no/crownMarch25.json": [
		49054,
		49054
	],
	"./no/crownWheelBlack.json": [
		49728,
		49728
	],
	"./no/crownWheelBlackLP.json": [
		5423,
		5423
	],
	"./no/cryptoExclusiveMay25LP.json": [
		38440,
		38440
	],
	"./no/cryptoOfferMay25LP.json": [
		76208,
		76208
	],
	"./no/deposits.json": [
		8762,
		8762
	],
	"./no/dialogs.json": [
		44522,
		44522
	],
	"./no/diceRoll.json": [
		70691,
		70691
	],
	"./no/dogTreasure.json": [
		42366,
		42366
	],
	"./no/dogTreasureTerms.json": [
		9817,
		9817
	],
	"./no/dragonLP.json": [
		82145,
		82145
	],
	"./no/dragonPearlsCoverflowLPTemplate.json": [
		76265,
		76265
	],
	"./no/dragonPearlsFebruary2026.json": [
		25611,
		25611
	],
	"./no/dragonPearlsMarch2026.json": [
		48973,
		48973
	],
	"./no/dragonPearlsNovember25LP.json": [
		80756,
		80756
	],
	"./no/easterApril2025.json": [
		261,
		261
	],
	"./no/easterApril2026.json": [
		12792,
		12792
	],
	"./no/easterMissions.json": [
		77635,
		77635
	],
	"./no/fiestaJune25LP.json": [
		42270,
		42270
	],
	"./no/fifa2026LP.json": [
		35947,
		35947
	],
	"./no/fruitCircusParty.json": [
		47997,
		47997
	],
	"./no/fruitsupMarch25.json": [
		4684,
		4684
	],
	"./no/gatesOfOlympusLP.json": [
		28329,
		28329
	],
	"./no/glossary.json": [
		35060,
		35060
	],
	"./no/halloween2026LP.json": [
		25748,
		25748
	],
	"./no/halloweenPromo26.json": [
		97763,
		97763
	],
	"./no/headlinePromo.json": [
		25821,
		25821
	],
	"./no/history.json": [
		56292,
		56292
	],
	"./no/jackpot.json": [
		4394,
		4394
	],
	"./no/juicyCarMay2025.json": [
		52240,
		52240
	],
	"./no/juicyMay.json": [
		99015,
		99015
	],
	"./no/kickupLP.json": [
		39438,
		39438
	],
	"./no/leaveDeposit.json": [
		63204,
		63204
	],
	"./no/leaveRegistration.json": [
		58765,
		58765
	],
	"./no/limits.json": [
		5348,
		5348
	],
	"./no/lobby.json": [
		97503,
		97503
	],
	"./no/lootboxes.json": [
		34400,
		34400
	],
	"./no/loyalty.json": [
		3378,
		3378
	],
	"./no/lpAssets.json": [
		12997,
		12997
	],
	"./no/lyzer40BanksBenefitsJune2025LP.json": [
		15064,
		15064
	],
	"./no/march2025.json": [
		13429,
		13429
	],
	"./no/matchlvlLP.json": [
		80036,
		80036
	],
	"./no/mission.json": [
		21956,
		21956
	],
	"./no/mobileApp.json": [
		28088,
		28088
	],
	"./no/mybeerLP.json": [
		56652,
		56652
	],
	"./no/odyssey-promo.json": [
		63132,
		63132
	],
	"./no/offerCardNovember2025LP.json": [
		195,
		195
	],
	"./no/oktoberfest.json": [
		89106,
		89106
	],
	"./no/personal.json": [
		7595,
		7595
	],
	"./no/profile.json": [
		11490,
		11490
	],
	"./no/promotions.json": [
		35075,
		35075
	],
	"./no/pumpkinKingdom.json": [
		25580,
		21464
	],
	"./no/quest.json": [
		58130,
		58130
	],
	"./no/redDragon3.json": [
		92668,
		92668
	],
	"./no/referralSystem.json": [
		9421,
		9421
	],
	"./no/regDragonRewards.json": [
		92986,
		92986
	],
	"./no/regDragonRewardsAugust25LP.json": [
		74764,
		74764
	],
	"./no/regDragonRewardsOctober25LP.json": [
		20429,
		20429
	],
	"./no/regDragonRewardsSports.json": [
		61299,
		61299
	],
	"./no/regRewards.json": [
		55225,
		55225
	],
	"./no/rewards.json": [
		13393,
		13393
	],
	"./no/royalupLP.json": [
		50435,
		50435
	],
	"./no/scoreupLP.json": [
		49205,
		95556
	],
	"./no/scratchGame.json": [
		62225,
		62225
	],
	"./no/security.json": [
		3065,
		3065
	],
	"./no/sharkJuly25LP.json": [
		4519,
		4519
	],
	"./no/slotsCircle.json": [
		18195,
		18195
	],
	"./no/slotsStepsAugust2025LP.json": [
		349,
		349
	],
	"./no/slotwinLP.json": [
		96967,
		96967
	],
	"./no/sportsDeposit.json": [
		64303,
		64303
	],
	"./no/sportslvlLP.json": [
		70697,
		70697
	],
	"./no/stPatrick2026.json": [
		15093,
		15093
	],
	"./no/sunOfEgypt.json": [
		75152,
		75152
	],
	"./no/support.json": [
		93543,
		93543
	],
	"./no/tournaments.json": [
		53801,
		53801
	],
	"./no/turbolvlJuly25LP.json": [
		67958,
		67958
	],
	"./no/validation.json": [
		30740,
		30740
	],
	"./no/verification.json": [
		84738,
		84738
	],
	"./no/vip.json": [
		48258,
		48258
	],
	"./no/vipGemCards.json": [
		61449,
		61449
	],
	"./no/welcomeApril2025.json": [
		55265,
		55265
	],
	"./no/welcomeSeptemberLP.json": [
		45800,
		45800
	],
	"./no/wheel.json": [
		22357,
		22357
	],
	"./no/wheelFortuneLP.json": [
		12148,
		12148
	],
	"./no/winterJanuary.json": [
		57229,
		57229
	],
	"./no/withdraw.json": [
		85873,
		85873
	],
	"./no/wolfElvisSunBuffalo.json": [
		58789,
		58789
	],
	"./no/wolfWheelLP.json": [
		16379,
		16379
	],
	"./no/worldcup2026LP.json": [
		15183,
		15183
	],
	"./no/xmasJanuary2026.json": [
		24869,
		24869
	],
	"./no/xmasbonusNovember2025LP.json": [
		99887,
		99887
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 90492;
module.exports = webpackAsyncContext;